import { queryOptions } from "@tanstack/react-query";
import axios from "axios";

/**
 * Creates a query options object for fetching users, intended for use with React Query.
 *
 * @param {Object} params - The parameters used for filtering, pagination, or search.
 * @param {Object} [options] - Optional additional query options (e.g., staleTime, enabled).
 * @returns {import('@tanstack/react-query').QueryOptions} A React Query options object configured for fetching users.
 */
export default function createUsersQueryOptions(params, options) {
  return queryOptions({
    queryKey: ["users", params],
    queryFn: () => getUsers(params),
    ...options,
  });
}

const getUsers = async (params = {}) => {
  const response = await axios.get("/api/users", { params });
  return response.data;
};
